<template>
  <div>
    <el-dropdown @command="handleCommand">
      <el-button type="primary" class="btn" size="small">
        PRINT
        <i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="printStandard">Standard</el-dropdown-item>
        <el-dropdown-item command="printWithouPrice">Without Price</el-dropdown-item>
        <el-dropdown-item command="manualMark">Manual Mark</el-dropdown-item>
        <!-- <el-dropdown-item command="printDelivery">Delivery</el-dropdown-item>
        <el-dropdown-item command="printDeliveryWithouPrice">Without Price</el-dropdown-item>-->
      </el-dropdown-menu>
    </el-dropdown>
    <PrintTplStandard v-show="printTplShow" :withOutPriceInfos="withOutPriceInfos" />
  </div>
</template>

<script>
import { getLodop } from '../utils/LodopFuncs'
import { standardStyle } from '../utils/StyleTplStandard'
import PrintTplStandard from './BtnPrintTplStandard'
import { markPrint } from '../api'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'BtnPrint',
  components: {
    PrintTplStandard
  },
  props: {
    orderNo: Number
  },
  data () {
    return {
      printTplShow: false,
      withOutPriceInfos: false
    }
  },
  computed: {
    ...mapState('edit', ['id'])
  },
  inject: ['reload', 'bus'],
  methods: {
    ...mapActions({
      init: 'edit/initShow'
    }),
    handleCommand (command) {
      if (command === 'printStandard') {
        this.withOutPriceInfos = false
        this.$nextTick(() => {
          this._print(this.orderNo)
        })
      }
      if (command === 'printWithouPrice') {
        this.withOutPriceInfos = true
        this.$nextTick(() => {
          this._print(this.orderNo)
        })
      }
      if (command === 'manualMark') {
        this._submitPrintSuccuess()
      }
    },
    async _submitPrintSuccuess () {
      // console.log('now submitting to  server for having printed')
      await markPrint(this.id)
      await this.init(this.id)
      this.bus.$emit('order-line-changed')
    },
    _print (invNo) {
      var that = this
      var LODOP = getLodop()
      var strBodyStyle = `<style>${standardStyle}</style>`
      var strHeader =
        strBodyStyle +
        '<body>' +
        document.getElementById('header').innerHTML +
        '</body>'
      var strLines =
        strBodyStyle +
        '<body>' +
        document.getElementById('line-content').innerHTML +
        '</body>'
      var strLinesTotal =
        strBodyStyle +
        '<body>' +
        document.getElementById('lines-total').innerHTML +
        '</body>'
      var strFooter =
        strBodyStyle +
        '<body>' +
        document.getElementById('footer').innerHTML +
        '</body>'
      LODOP.PRINT_INIT('Printing Sheets')
      LODOP.SET_PRINT_STYLE('FontName', 'Arial')
      LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4') // 因为为了兼容刘老师的远程打印，所以改本行参数
      // 打印watermark水印
      // ADD_PRINT_HTM(Top,Left,Width,Height,strHtmlContent)
      LODOP.ADD_PRINT_HTM(-60, -60, '100%', '100%', document.getElementById('bgimg').innerHTML)
      // 打印头部
      LODOP.ADD_PRINT_HTM('3.3%', '5%', '90%', '37%', strHeader)
      LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1)
      LODOP.SET_PRINT_STYLEA(0, 'Horient', 2)
      // 打印表格
      LODOP.ADD_PRINT_TABLE('24%', '5%', '90%', '47%', strLines)
      LODOP.SET_PRINT_STYLEA(0, 'Horient', 2)
      // 打印总计区
      LODOP.ADD_PRINT_HTM('1%', '0%', '90%', '20%', strLinesTotal)
      LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', -1)
      LODOP.SET_PRINT_STYLEA(0, 'Horient', 2)
      // 打印尾部
      LODOP.ADD_PRINT_HTM('78%', '5%', '90%', '35%', strFooter)
      LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1)
      LODOP.SET_PRINT_STYLEA(0, 'Horient', 2)
      // 打印顶部页数页码
      LODOP.ADD_PRINT_TEXT('2%', '45%', 42, 20, 'Page:')
      LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1)
      LODOP.ADD_PRINT_TEXT('2%', '50%', 24, 20, '')
      LODOP.SET_PRINT_STYLEA(0, 'ItemType', 2)
      LODOP.ADD_PRINT_TEXT('2%', '52%', 10, 20, '/')
      LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1)
      LODOP.ADD_PRINT_TEXT('2%', '53%', 24, 20, '')
      LODOP.SET_PRINT_STYLEA(0, 'ItemType', 3)
      // 打印底部页数页码
      LODOP.ADD_PRINT_TEXT('97%', '45%', 42, 20, 'Page:')
      LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1)
      LODOP.ADD_PRINT_TEXT('97%', '50%', 24, 20, '')
      LODOP.SET_PRINT_STYLEA(0, 'ItemType', 2)
      LODOP.ADD_PRINT_TEXT('97%', '52%', 10, 20, '/')
      LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1)
      LODOP.ADD_PRINT_TEXT('97%', '53%', 24, 20, '')
      LODOP.SET_PRINT_STYLEA(0, 'ItemType', 3)
      // 打印条形码
      // LODOP.ADD_PRINT_BARCODE('96%', '5%', 200, 30, '128A', invNo)
      // 打印底部时间
      LODOP.ADD_PRINT_TEXT('97%', '5%', 260, 20, `Timestamp: ${new Date().toLocaleString()}`)
      LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1)
      // 单独打印logo
      // LODOP.ADD_PRINT_IMAGE('5%', '5%', 200, 30, '<img src="https://s1.imgsha.com/2024/07/08/printlogoBW1.png"/>')
      LODOP.ADD_PRINT_IMAGE('5%', '5%', 200, 30, '<img src="https://s2.imgsha.com/2025/11/04/printlogoBW-outline1.png"/>')
      LODOP.SET_PRINT_STYLEA(0, 'Stretch', 2) // 按原图比例(不变形)缩放模式
      // 启动预览
      LODOP.SET_PREVIEW_WINDOW(0, 0, 0, 0, 0, 'Printing Sheets')
      LODOP.SET_PRINT_MODE('AUTO_CLOSE_PREWINDOW', 1)
      LODOP.PREVIEW()
      // LODOP.PRINT_DESIGN()
      // 判断是否实际打印
      if (LODOP.VERSION) {
        LODOP.On_Return = function (TaskID, Value) {
          if (Value > 0) {
            console.log(
              'user have pressed the print btn and task value is : ' + Value
            )
            that.$message({
              showClose: true,
              duration: 0,
              message: 'Print successful',
              type: 'success'
            })
            that._submitPrintSuccuess()
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  background-color: #32c5d2;
  border-color: #32c5d2;
  margin-left: 10px;
}
.btn:hover,
.btn:focus {
  background-color: #46d2df;
  border-color: #46d2df;
}
</style>
